/**
 * 加载xml字符串
 */
export const loadXMLText = text => {
  if (!text) return
  let xmlDoc
  try {
    //Internet Explorer
    xmlDoc = new ActiveXObject('Microsoft.XMLDOM')
    xmlDoc.async = 'false'
    xmlDoc.loadXML(text)
  } catch (e) {
    try {
      //Firefox, Mozilla, Opera, etc.
      let parser = new DOMParser()
      xmlDoc = parser.parseFromString(text, 'text/xml')
    } catch (e) {}
  }

  return xmlDoc
}
/**
 * 加载xml文件
 */
export const loadXMLFile = file => {
  let xmlDoc
  try {
    //Internet Explorer
    xmlDoc = new ActiveXObject('Microsoft.XMLDOM')
  } catch (e) {
    try {
      //Firefox, Mozilla, Opera, etc.
      xmlDoc = document.implementation.createDocument('', '', null)
    } catch (e) {
      alert(e.message)
    }
  }
  try {
    xmlDoc.async = false
    xmlDoc.load(file)
  } catch (e) {}
  return xmlDoc
}
